import { supabase } from './supabase';

export async function fetchAttachments({ newsPostId, eventId }) {
  let query = supabase.from('file_attachments').select('*').order('created_at', { ascending: true });
  if (newsPostId) query = query.eq('news_post_id', newsPostId);
  if (eventId) query = query.eq('event_id', eventId);
  const { data, error } = await query;
  if (error) throw error;
  return data;
}

export async function addAttachment(attachment) {
  const { data, error } = await supabase
    .from('file_attachments')
    .insert(attachment)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteAttachment(id) {
  const { error } = await supabase.from('file_attachments').delete().eq('id', id);
  if (error) throw error;
}
